import { render, staticRenderFns } from "./inputs.vue?vue&type=template&id=2f62bbe9&scoped=true"
import script from "./inputs.vue?vue&type=script&lang=js"
export * from "./inputs.vue?vue&type=script&lang=js"
import style0 from "./inputs.vue?vue&type=style&index=0&id=2f62bbe9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f62bbe9",
  null
  
)

export default component.exports